import { DOCUMENT, inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CoreConstant, UserPreferenceConstant } from '../constant/base.constant';
import { WhoAmI } from '../model/user/whoAmI.model';
import { clearAuthCookie, writeAuthCookie } from '../util/auth-cookie.util';

@Injectable({
    providedIn: 'root',
})
export class UserContextService {
    private readonly _document: Document = inject(DOCUMENT);
    private readonly _userContext = new BehaviorSubject<WhoAmI | null>(null);
    private readonly _userToken = new BehaviorSubject<string | null>(null);

    public setContext(userContext: WhoAmI | null) {
        this._userContext.next(userContext);
    }

    public getContext(): Observable<WhoAmI | null> {
        return this._userContext.asObservable();
    }

    public setToken(userToken: string | null) {
        if (userToken) {
            localStorage.setItem(CoreConstant.X_AUTH_TOKEN, userToken);
            writeAuthCookie(this._document, userToken);
        } else {
            clearAuthCookie(this._document);
        }
        this._userToken.next(userToken);
        this._userToken.complete();
    }

    public getToken(): Observable<string | null> {
        return this._userToken.asObservable();
    }

    public getTokenFromStorage(): string | null {
        const session = sessionStorage.getItem(CoreConstant.X_AUTH_TOKEN);
        return session != null && session != '' ? session : localStorage.getItem(CoreConstant.X_AUTH_TOKEN);
    }

    public syncAuthCookieFromStorage(): void {
        const token = this.getTokenFromStorage();
        if (token) {
            writeAuthCookie(this._document, token);
            return;
        }

        clearAuthCookie(this._document);
    }

    public clear() {
        sessionStorage.clear();
        localStorage.removeItem(CoreConstant.X_AUTH_TOKEN);
        localStorage.removeItem(UserPreferenceConstant.TASK_SEARCH_TASKS_FOR_NAVIGATION);
        this.setToken(null);
        this.setContext(null);
    }

    public clearSessionOnly() {
        sessionStorage.clear();
        this.setContext(null);
        this.syncAuthCookieFromStorage();
    }
}
